import React, {useEffect, useRef, useState} from 'react';
import { Animated, Dimensions, ScrollView, Text, useWindowDimensions, View} from 'react-native';
import PaginationDots from '../paginationDots/paginationDots';
import { getCleanUrl } from '../../utils/Helper';
import { useCssStyle } from '../../customHook/getCssStyle';
import RenderHTML from 'react-native-render-html';
import { ImageComp } from '../Image/Image';
import CustomPressable from '../customPressable/customPressable';

const {width: screenWidth} = Dimensions.get('window');

const InfoPageScrollWidget = (props) => {
  const { listItemData = [], handleOnWidgetClick, widget } = props || {};
  const getStyles = useCssStyle();
  const { width } = useWindowDimensions();

  const scrollX = useRef(new Animated.Value(0)).current;
  const scrollViewRef = useRef(null);
  const debounceTimeout = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);

  const [parentWidth, setParentWidth] = useState(screenWidth);

  const interval = useRef(null);

  const handleResetScroll = () => {
    if (interval.current) {
      clearInterval(interval.current);
    }

    interval.current = setInterval(() => {
      setActiveIndex(prevIndex => {
        const nextIndex = prevIndex + 1;

        if (nextIndex < listItemData.length) {
          scrollViewRef.current?.scrollTo({
            x: nextIndex * parentWidth,
            animated: true,
          });
          return nextIndex;
        }
        scrollViewRef.current?.scrollTo({
            x: 0,
            animated: true,
        });
        return 0;
      });
    }, 7000);

  }
  useEffect(() => {
    if (listItemData.length <= 1) return;
    handleResetScroll();

    return () => clearInterval(interval.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [parentWidth, listItemData.length]);

   

  const handleScroll = event => {
    handleResetScroll();
    const offsetX = event.nativeEvent.contentOffset.x;
    clearTimeout(debounceTimeout.current);

    debounceTimeout.current = setTimeout(() => {
      const index = Math.round(offsetX / parentWidth);
      setActiveIndex(index);
    }, 100);
  };

  if (!listItemData.length) {
    return null;
  }


  return (
    <View 
      onLayout={(event) => {
          const { width } = event.nativeEvent.layout;
          setParentWidth(width);
      }}
    >
      <Animated.ScrollView
        ref={scrollViewRef}
        horizontal
        pagingEnabled
        showsHorizontalScrollIndicator={false}
        onScroll={Animated.event(
          [{nativeEvent: {contentOffset: {x: scrollX}}}],
          {useNativeDriver: false, listener: handleScroll},
        )}
        scrollEventThrottle={16}
        style={{flexGrow: 0}}
      >
          {listItemData.map(widgetData => {
            let widgetImg = widgetData.btnImageUrl ? getCleanUrl(widgetData.btnImageUrl) : null;
            const customWidgetTitleStyle = getStyles(['infoPageScrollWidgetHeaderTitle', `infoPageScrollWidgetHeaderTitle_${widgetData.widgetMetaHtmlId}`, `infoPageScrollWidgetHeaderTitle_${widgetData.id}`]);

            const customWidgetSubTitleStyle = getStyles(['infoPageScrollWidgetHeaderSubtitle', `infoPageScrollWidgetHeaderSubtitle_${widgetData.widgetMetaHtmlId}`, `infoPageScrollWidgetHeaderSubtitle_${widgetData.id}`]);

            return (
              <View key={widgetData.id} style={getStyles(['infoPageScrollWidgetsWidgetContainer', `infoPageScrollWidgetsWidgetContainer_${widgetData.widgetMetaHtmlId}`, `infoPageScrollWidgetsWidgetContainer_${widgetData.id}`, { width: parentWidth }])} id={`infoPageScrollWidgetsWidgetContainer infoPageScrollWidgetsWidgetContainer_${widgetData.widgetMetaHtmlId}`}>
                {widgetData.widgetTitle && (
                  <RenderHTML
                    contentWidth={width}
                    baseStyle={customWidgetTitleStyle}
                    source={{html: widgetData.widgetTitle}}
                    systemFonts={[customWidgetTitleStyle.fontFamily]}
                    id={`infoPageScrollWidgetHeaderTitle infoPageScrollWidgetHeaderTitle_${widgetData.widgetMetaHtmlId} infoPageScrollWidgetHeaderTitle_${widgetData.id}`}
                  />
                )}
                {widgetImg && (<ImageComp source={widgetImg} style={getStyles(['infoPageScrollWidgetImageStyle', `infoPageScrollWidgetImageStyle_${widgetData.widgetMetaHtmlId}`, `infoPageScrollWidgetImageStyle_${widgetData.id}`])} id={`infoPageScrollWidgetImageStyle infoPageScrollWidgetImageStyle_${widgetData.widgetMetaHtmlId}`} />)}

                {widgetData.widgetDesc && (
                  <View style={customWidgetSubTitleStyle}>
                    <RenderHTML
                      contentWidth={width}
                      baseStyle={customWidgetSubTitleStyle}
                      source={{html: widgetData.widgetDesc}}
                      systemFonts={[customWidgetSubTitleStyle.fontFamily]}
                      id={`infoPageScrollWidgetHeaderSubtitle infoPageScrollWidgetHeaderSubtitle_${widgetData.widgetMetaHtmlId}`}
                    />
                  </View>
                )}

                {widgetData.buttonTitle && (
                  <CustomPressable onPress={() => handleOnWidgetClick(widgetData)} style={getStyles(['infoPageScrollWidgetButtonContainer', `infoPageScrollWidgetButtonContainer_${widgetData.widgetMetaHtmlId}`, `infoPageScrollWidgetButtonContainer_${widgetData.id}` ])}
                    id={`infoPageScrollWidgetButtonContainer infoPageScrollWidgetButtonContainer_${widgetData.widgetMetaHtmlId}`}>
                      
                    <Text style={getStyles(['infoPageScrollWidgetButtonContainerText', `infoPageScrollWidgetButtonContainerText_${widgetData.widgetMetaHtmlId}`, `infoWidgetButtonContainerText_${widgetData.id}`])} id={`infoPageScrollWidgetButtonContainerText infoPageScrollWidgetButtonContainerText_${widgetData.widgetMetaHtmlId}`}>
                      {widgetData.buttonTitle}
                    </Text>
                  </CustomPressable>
                )}
              </View>
            );
          })}
      </Animated.ScrollView>

      <View style={getStyles(['widgetmainContainerChildContainer', 'infoPageScrollMainContainerChildContainer'])} id='widgetmainContainerChildContainer infoPageScrollMainContainerChildContainer'>
        <PaginationDots
          totalDots={listItemData.length}
          activeIndex={activeIndex}
          animatedValue={scrollX}
          dotStyle="infoPageScrollPaginationDot"
          activeDotStyle="infoPageScrollActivePaginationDot"
        />
      </View>
    </View>
  );
};

export default InfoPageScrollWidget;
